import React, { forwardRef, Ref } from "react";
import "./bp2Button.less";

type ButtonType = "danger" | "primary" | "default" | "link" | "secondary" | "third" | "disabled";

export const buttonTypeValues: ButtonType[] = [
   "danger",
   "primary",
   "default",
   "link",
   "secondary",
   "third",
   "disabled",
];

interface ButtonProps {
   size?: "small" | "regular" | "medium" | "large";
   className?: string;
   onClick?: React.MouseEventHandler<HTMLButtonElement>;
   onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
   onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
   onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
   children?: React.ReactNode;
   buttonType?: ButtonType | undefined;
   danger?: boolean;
   round?: boolean;
   id?: string;
   disabled?: boolean;
   htmlType?: "submit" | "reset" | "button";
   style?: React.CSSProperties;
   hidden?: boolean;
   datatestid?: string;
   onContextMenu?: any;
   title?: string;
}

export const Button = forwardRef(
   (
      {
         size = "medium",
         buttonType = "default",
         danger = false,
         onClick,
         className = "",
         id,
         disabled = false,
         htmlType = "button",
         style = {},
         hidden = false,
         children,
         datatestid,
         onMouseEnter,
         onMouseLeave,
         onMouseDown,
         onContextMenu,
         title,
      }: ButtonProps,
      ref: Ref<HTMLButtonElement>,
   ) => {
      const btnType = buttonType === "danger" ? "primary" : buttonType;
      const isDanger = buttonType === "danger" ? true : danger;

      return (
         <button
            onContextMenu={onContextMenu}
            ref={ref}
            data-testid={datatestid}
            id={id}
            type={htmlType}
            title={title}
            style={style}
            hidden={hidden}
            className={`bp2-button non-selectable bp2-btn-${size.charAt(
               0,
            )} bp2-btn-${btnType.substring(0, 3)} bp2-btn-danger-${isDanger} bp2-disabled-${disabled} ${className}`}
            disabled={disabled}
            onClick={buttonType !== "disabled" ? onClick : undefined}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseDown={onMouseDown}
         >
            {children}
         </button>
      );
   },
);
